const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "job":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "job",
    reducer: reducer,
};

export default data;